import React from 'react'
import { ChevronDoubleRightIcon } from '@heroicons/react/24/solid'
import { BaseButton } from '@verifier-user/verifier-headless-ui'

export const Employer = ({ employer, updateEmployer, index, removeEmployer }) => {
  return (
    <div>
      <label className='block cq-w-sm:w-2/3 cq-w-md:w-1/2'>
        Employer Name
        <span className='text-red-500'>*</span>
        <input
          id={`name-${index}`}
          value={employer?.name ?? ''}
          onChange={(e) => {
            updateEmployer('name', e.target.value)
          }}
          className='verifier-input'
          required
          placeholder='Employer Name'
        />
      </label>
      <label className='block cq-w-sm:w-2/3 cq-w-md:w-1/2'>
        Stated Income
        <span className='text-red-500'>*</span>
        <input
          id={`statedIncome-${index}`}
          type={'number'}
          value={employer?.statedIncome ?? ''}
          onChange={(e) => {
            updateEmployer('statedIncome', e.target.value)
          }}
          className='verifier-input'
          required
          placeholder='Stated Income'
        />
        {index > 0 && (
          <BaseButton
            type='button'
            data-testid={`btn-remove-employer-${index}`}
            className='mt-2 mb-4'
            onClick={removeEmployer}
          >
            Remove employer
            <ChevronDoubleRightIcon className='w-4 h-4 inline' />
          </BaseButton>
        )}
      </label>
    </div>
  )
}
